import React from 'react'
import styled from 'styled-components'
import hexToRgba from 'hex-to-rgba'

import SvgCircle from './SvgCircle'

/**
* @author zilahir
* @function TimelineItem
**/

const Item = styled.div`
	&:before {
		background-color: ${props => props.color};
		opacity: .1;
	}
	&:hover {
		cursor: pointer;
		background-color: ${hexToRgba('#ffffff', 0.1)};
		transition: all 0.2s ease;
	}
`

const TimelineItem = props => {
	const { color, onClick } = props
	return(
		<Item
			className="timeline-item"
			color={color}
			onClick={onClick}
		>
			<SvgCircle />
			<h1>
				09:00 – 10:00
			</h1>
			<h2>
				Opening
			</h2>
		</Item>
	 )

 }

export default TimelineItem